module.exports = __webpack_public_path__ + "static/media/cg.0e4b32a2.webp";